module.exports = __webpack_public_path__ + "media/images/flags/ar-40a9330d388164220b9fdaa47becb9df.svg";